import type { TPortfolioCategory } from './portfolioCatalog'

export const heroImage = `${process.env.PUBLIC_URL}/portfolio.png`

// label = i18n key
export const filters: Array<{ key: TPortfolioCategory | 'all'; label: string }> = [
  { key: 'all', label: 'all' },
  { key: 'residential', label: 'filterResidential' },
  { key: 'public', label: 'filterPublic' },
]

export const categoryLabel: Record<TPortfolioCategory, string> = {
  residential: 'filterResidential',
  public: 'filterPublic',
}
